import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import { useCallback, useState } from 'react';
/* This hooks will perform some logic to create a list of items which are checked and to
get the list of checked items id's  */

/* we will return the checkedItems array and  onSelectListItem a function */

function useMultiSelectOption() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      checkedItems = _useState2[0],
      setCheckedItems = _useState2[1]; // React.useEffect(() => {
  //   setCheckedItems(checkedDataArr)
  // }, [checkedDataArr])


  var onSelectListItem = useCallback(function (e, data, item) {
    var itemIndex = checkedItems.length > 0 && checkedItems.map(function (option) {
      return option.value;
    }).indexOf(item.value);

    var selectedItems = _toConsumableArray(checkedItems);

    if (data.checked) {
      selectedItems = [].concat(_toConsumableArray(checkedItems), [item]);
    } else {
      selectedItems.splice(itemIndex, 1);
    }

    setCheckedItems(selectedItems);
  }, [checkedItems]);
  return [checkedItems, onSelectListItem];
}

export default useMultiSelectOption;